export default __webpack_public_path__ + "static/logo-PH-small-d5a4bb653f80a0b96e9617eeaaed22a9.svg";